import { Home, LayoutGrid, Settings, LogOut, Bell, Search, PlusCircle, Calendar, Users, MapPin, CheckCircle2, ChevronRight, ChevronLeft, ChevronDown, ChevronsUpDown, Cake, Heart, GraduationCap, Baby, PartyPopper, Briefcase, Utensils, MoreHorizontal, ArrowRight, ArrowLeft, Rocket, X, Copy, Mail, MessageCircle, Share2, ExternalLink, Menu, PanelLeftClose, PanelLeftOpen, BarChart3, FileText, CreditCard, History, MessageSquareText, MessagesSquare, LifeBuoy, User, UploadCloud, Moon, Sun, Shield, Lock, Smartphone, Trash2, Globe, Palette, Link2, Sparkles, AlertTriangle, Check, Eye, EyeOff, Type, Clock, Download, Languages, Monitor, Crown, Zap, Plug, Camera, Archive, Edit3, Filter, ArchiveRestore, Ban, RotateCcw, Gift, ClipboardList, Cpu } from 'lucide-react';

export const Icons = {
  Cpu,
  Home,
  Dashboard: LayoutGrid,
  Settings,
  LogOut,
  Bell,
  Search,
  Plus: PlusCircle,
  Calendar,
  Users,
  MapPin,
  CheckCircle: CheckCircle2,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  ChevronsUpDown,
  Menu,
  PanelLeftClose,
  PanelLeftOpen,
  Analytics: BarChart3,
  Templates: FileText,
  FileText,
  Subscription: CreditCard,
  History,
  Feedback: MessageSquareText,
  Chat: MessagesSquare,
  Help: LifeBuoy,
  Birthday: Cake,
  Wedding: Heart,
  Graduation: GraduationCap,
  BabyShower: Baby,
  Party: PartyPopper,
  Corporate: Briefcase,
  Dinner: Utensils,
  Other: MoreHorizontal,
  MoreHorizontal,
  ArrowRight,
  ArrowLeft,
  Rocket,
  X,
  Copy,
  Mail,
  WhatsApp: MessageCircle,
  Share: Share2,
  ExternalLink,
  User,
  Upload: UploadCloud,
  Moon,
  Sun,
  Shield,
  Lock,
  Device: Smartphone,
  Trash: Trash2,
  Globe,
  Palette,
  Link: Link2,
  Sparkles,
  Warning: AlertTriangle,
  Check,
  Eye,
  EyeOff,
  Type,
  Clock,
  Download,
  Languages,
  Monitor,
  Crown,
  Zap,
  Plug,
  Camera,
  Archive,
  Edit3,
  Filter,
  ArchiveRestore,
  Ban,
  RotateCcw,
  Partner: Briefcase,
  Gift,
  Rsvp: ClipboardList,
};
